// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3136 ? "e5d5d81c" : chunkId) + "." + {"3136":"f3a82c926398c5cc","4579":"5f3e32370662e1ff"}[chunkId] + ".js";
};